import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Image as ImageIcon, Calendar, Download, Eye } from 'lucide-react';
import { cldThumb } from '../../lib/cloudinary';

const MyPhotosGrid = ({ photos, setLightbox, downloadFromUrl, i18n }) => {
  if (!photos.length) {
    return (
      <div className="max-w-7xl mx-auto mb-8">
        <Card className="bg-[#0d3d3d]/60 border-white/10">
          <CardContent className="py-10 text-center text-white/60">
            <ImageIcon className="w-10 h-10 mx-auto mb-2 text-white/30" />
            <p className="text-sm">{i18n.language === 'nl' ? "Nog geen foto's beschikbaar." : 'No photos available yet.'}</p>
          </CardContent>
        </Card>
      </div>
    );
  }
  return (
    <div className="max-w-7xl mx-auto mb-8" data-testid="client-photos-section">
      <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-2">
        <ImageIcon className="w-6 h-6 text-[#3da5a5]" /> {i18n.language === 'nl' ? "Mijn Foto's" : 'My Photos'} ({photos.length})
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
        {photos.map((p, i) => {
          const src = cldThumb(p.cloudinary_thumbnail || p.thumbnail || p.cloudinary_url || p.url, 400);
          const full = p.cloudinary_url || p.url;
          const filename = `Cardoso_${(p.entry_date || 'foto').replace(/[^a-z0-9-]/gi, '_')}_${i + 1}.jpg`;
          return (
            <div key={i} className="relative group bg-[#0d3d3d]/60 rounded-lg overflow-hidden aspect-square border border-white/10 hover:border-[#3da5a5]/60 transition-all">
              <img src={src} alt={p.filename || `Foto ${i + 1}`} className="w-full h-full object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-end justify-center gap-1.5 p-2">
                <Button
                  size="sm"
                  variant="ghost"
                  onClick={() => setLightbox({ open: true, index: i })}
                  className="bg-white/20 text-white hover:bg-white/30 h-8 px-2"
                  data-testid={`client-photo-view-${i}`}
                >
                  <Eye className="w-3 h-3 mr-1" /> {i18n.language === 'nl' ? 'Open' : 'View'}
                </Button>
                <Button
                  size="sm"
                  onClick={() => downloadFromUrl(full, filename)}
                  className="bg-[#3da5a5] hover:bg-[#2d8585] h-8 px-2"
                  data-testid={`client-photo-download-${i}`}
                >
                  <Download className="w-3 h-3" />
                </Button>
              </div>
              {p.entry_date && (
                <span className="absolute top-1 left-1 bg-black/60 text-white text-[10px] px-1.5 py-0.5 rounded flex items-center gap-1">
                  <Calendar className="w-2.5 h-2.5" /> {p.entry_date}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MyPhotosGrid;
